import { createContext } from "react";

/**
 * O objeto de contexto vive em um módulo isolado (sem imports de valor).
 * Isso evita que ciclos de importação / recarregamentos parciais criem
 * duas instâncias diferentes do contexto — causa do erro
 * "useFinance must be used within FinanceProvider" mesmo com o provider na árvore.
 */
export const FinanceContextObject = createContext<any>(null);
